/* unplugin-vue-components disabled */import { render } from "./routedata.vue?vue&type=template&id=b5523c3c&scoped=true"
import script from "./routedata.vue?vue&type=script&lang=js"
export * from "./routedata.vue?vue&type=script&lang=js"

import "./routedata.vue?vue&type=style&index=0&id=b5523c3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5523c3c"]])

export default __exports__